import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import contract from "./contract.vue";
export default {
  name: "house-sign-contract",
  components: {
    contract: contract
  },
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20
      },
      // 搜索表单

      status: [{
        val: 1,
        label: "被拒绝"
      }, {
        val: 2,
        label: "待确认"
      }, {
        val: 3,
        label: "已同意"
      }, {
        val: 4,
        label: "押金冻结中"
      }, {
        val: 5,
        label: "已退还给房客"
      }, {
        val: 6,
        label: "已成交"
      }],
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数

      contractInfo: {},
      contractDialogVisible: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    print: function print(id) {
      window.open(location.origin + location.pathname + "/#/print-contract?id=" + id);
    },
    getContractInfo: function getContractInfo(id) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.getContractInfo({
                id: id
              });
            case 1:
              res = _context2.v;
              _this2.contractInfo = res.data;
              _this2.contractDialogVisible = true;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    operationRefund: function operationRefund(id) {
      var _this3 = this;
      this.$prompt("请输入退款金额", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(res) {
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                _context3.n = 1;
                return _this3.$api.operationRefund({
                  id: id,
                  amount: res.value
                });
              case 1:
                _this3.$message.success("退款操作成功!");
              case 2:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function () {});
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (type === "search") {
                _this4.searchForm.pn = 1;
              }
              _this4.tableLoading = true;
              _context4.n = 1;
              return _this4.$api.getHouseApplyList(_this4.searchForm);
            case 1:
              res = _context4.v;
              _this4.tableData = res.data.list;
              _this4.total = res.data.count;
              _this4.tableLoading = false;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    }
  }
};